

































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "trafficList",
})
export default class TrafficList extends Vue {
  //data
  jsj = require("../../../../static/img/jsj.png");
  jshc = require("../../../../static/img/jshc.png");
  dache = require("../../../../static/img/dache.png");
  zuche = require("../../../../static/img/zuche.png");
  baoche = require("../../../../static/img/baoche.png");
  trafficServeTypes = [
    { value: "flight", label: "接送机", img: this.jsj },
    { value: "train", label: "接送站", img: this.jshc },
    { value: "taxi", label: "打车", img: this.dache },
    { value: "", label: "租车", img: this.zuche },
    { value: "oneday", label: "包车", img: this.baoche },
  ];

  //methods
  handleClick(type: any) {
    let __self = this;
    if (!type.value) {
      return __self.$toast("未开放，敬请谅解！");
    }
    __self.$router.push(`/mall/traffic/${type.value}`);
  }
}
